import { render, staticRenderFns } from "./BtDialog.vue?vue&type=template&id=078c9c3a&lang=pug"
import script from "./BtDialog.vue?vue&type=script&lang=js"
export * from "./BtDialog.vue?vue&type=script&lang=js"
import style0 from "./BtDialog.vue?vue&type=style&index=0&id=078c9c3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports